import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import TopicIndexSection from './components/TopicIndexSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ContactSection />
        <AboutSection />
        <RankingSection />
        <CardsSection />
        <CommentsSection />
        <TopicIndexSection />
        <AppSection />
        <CarouselSection />
        <MediaSection />
        <FAQSection />
        <TopicsSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}